import {
  Alert,
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import account from '../services/account-service';

const PREFIX = 'ForgotPasswordPage';
const classes = {
  root: `${PREFIX}-root`,
  card: `${PREFIX}-card`,
};
const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#0F1117',
  },
  [`& .${classes.card}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(4),
    backgroundColor: '#1a1d27',
    borderRadius: theme.shape.borderRadius,
    width: '100%',
    maxWidth: 400,
  },
}));

export default function ForgotPasswordPage() {
  const [identifier, setIdentifier] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!identifier) {
      setError('Please enter your username or email address.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      await account.forgotPassword({ identifier });
    } catch {
      // Silently ignore errors — always show success to prevent enumeration
    } finally {
      setLoading(false);
      setSubmitted(true);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Root className={classes.root}>
      <Box className={classes.card}>
        <Typography variant="h5" color="white" fontWeight={600}>
          Forgot Password
        </Typography>

        {submitted ? (
          <Alert severity="success" sx={{ width: '100%' }}>
            If that email is registered, a password reset link has been sent.
            Please check your inbox (and spam folder).
          </Alert>
        ) : (
          <>
            <Typography
              variant="body2"
              color="grey.400"
              textAlign="center"
            >
              Enter your username or email address and we'll send a password
              reset link to your registered email.
            </Typography>

            {error && (
              <Alert severity="error" sx={{ width: '100%' }}>
                {error}
              </Alert>
            )}

            <TextField
              fullWidth
              id="identifier"
              label="Username or Email Address"
              type="text"
              variant="outlined"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={loading}
            />

            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? <CircularProgress size={22} color="inherit" /> : 'Send Reset Link'}
            </Button>
          </>
        )}

        <Button
          variant="text"
          color="inherit"
          size="small"
          sx={{ color: 'grey.400' }}
          onClick={() => navigate('/login')}
        >
          Back to Login
        </Button>
      </Box>
    </Root>
  );
}
